import { memo } from "react"

const IconCreditCard = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.375 5.625H13.625"
        stroke="#002C98"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.48125 8.125H4.875"
        stroke="#002C98"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.75 11.875H4.25C3.21437 11.875 2.375 11.0356 2.375 10V5C2.375 3.96437 3.21437 3.125 4.25 3.125H11.75C12.7856 3.125 13.625 3.96437 13.625 5V10C13.625 11.0356 12.7856 11.875 11.75 11.875Z"
        stroke="#002C98"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default memo(IconCreditCard)
